/**
 * 마켓플레이스 통합 카테고리 (11개)
 * 웹과 앱 모두 이 카테고리를 사용합니다.
 */

export const MARKETPLACE_CATEGORIES = [
  { id: 'implant', name: '임플란트', icon: '🦷' },
  { id: 'restorative', name: '수복재료', icon: '🔧' },
  { id: 'endodontic', name: '근관치료', icon: '💉' },
  { id: 'preventive', name: '예방치료', icon: '🛡️' },
  { id: 'impression', name: '인상재료', icon: '🖐️' },
  { id: 'orthodontic', name: '교정재료', icon: '😁' },
  { id: 'surgical', name: '외과용품', icon: '✂️' },
  { id: 'hygiene', name: '위생용품', icon: '🧴' },
  { id: 'equipment', name: '장비', icon: '⚙️' },
  { id: 'lab-material', name: '기공재료', icon: '🏭' },
  { id: 'other', name: '기타', icon: '📦' },
];

export const CATEGORY_MAP = MARKETPLACE_CATEGORIES.reduce((map, cat) => {
  map[cat.id] = cat.name;
  return map;
}, {});

export const getCategoryName = (categoryId) => {
  return CATEGORY_MAP[categoryId] || categoryId;
};

export const ALL_CATEGORIES_WITH_ALL = [
  { id: 'all', name: '전체', icon: '🏪' },
  ...MARKETPLACE_CATEGORIES,
];

export default MARKETPLACE_CATEGORIES;
